import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChild,
  ElementRef,
  input,
  signal,
  TemplateRef,
  viewChild
} from '@angular/core';
import { NgbTooltip, Placement } from '@ng-bootstrap/ng-bootstrap';
import { TextEllipsisAppendDirective } from './text-ellipsis-append.directive';
import { TextEllipsisPrependDirective } from './text-ellipsis-prepend.directive';

const DEFAULT_HOST_CLASSES = 'mbs-text-ellipsis row g-0 flex-nowrap mw-100';

@Component({
  selector: 'mbs-text-ellipsis',
  templateUrl: './text-ellipsis.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbTooltip, NgTemplateOutlet],
  host: {
    '[class]': 'innerHostClasses()',
    '(mouseenter)': 'updateIsTruncated()'
  }
})
export class TextEllipsisComponent {
  public readonly autoClose = input<boolean>(false);
  public readonly closeDelay = input<number>(0);
  public readonly container = input<'body' | null>('body');
  public readonly disableTooltip = input<boolean>(false);
  public readonly openDelay = input<number>(0);
  public readonly placement = input<Placement | Array<Placement> | string>('top-left');
  public readonly tooltip = input<string | TemplateRef<any>>(null);
  public readonly tooltipClass = input<string>(null);
  public readonly triggers = input<string>('hover focus');
  public readonly hostClasses = input<string>('', { alias: 'class' });

  protected readonly innerHostClasses = computed<string>(() => DEFAULT_HOST_CLASSES + ' ' + this.hostClasses());
  protected readonly isTruncated = signal<boolean>(true);

  protected append = contentChild(TextEllipsisAppendDirective, { read: TextEllipsisAppendDirective, descendants: true });
  protected prepend = contentChild(TextEllipsisPrependDirective, { read: TextEllipsisPrependDirective, descendants: true });

  private wrapperSpan = viewChild('wrapper', { read: ElementRef<HTMLSpanElement> });
  private contentSpan = viewChild('content', { read: ElementRef<HTMLSpanElement> });

  protected updateIsTruncated(): void {
    const textEllipsisWidth = this.wrapperSpan().nativeElement.getBoundingClientRect().width;
    const spanWidth = this.contentSpan().nativeElement.getBoundingClientRect().width;

    this.isTruncated.set(textEllipsisWidth < spanWidth);
  }
}
